import { Download } from "lucide-react";

/**
 * Floating "Télécharger l'app" button — bottom-right corner on shop pages.
 * Visible on all breakpoints, points to /api/download smart link which
 * detects device and redirects to App Store or Play Store.
 */
export const AppDownloadFAB = () => (
  <a
    data-testid="app-download-fab"
    href="/api/download"
    className="fixed bottom-5 right-5 z-40 group inline-flex items-center gap-2 rounded-full bg-[#F5A800] text-[#16241B] px-4 py-3 md:px-5 md:py-3.5 shadow-[0_15px_40px_rgba(245,168,0,0.5)] hover:bg-[#0E7A3B] hover:text-white hover:-translate-y-0.5 hover:shadow-[0_18px_50px_rgba(14,122,59,0.5)] transition-all duration-300"
    aria-label="Télécharger l'application Zafara"
  >
    <Download className="h-4 w-4 md:h-5 md:w-5 group-hover:animate-pulse" />
    <span className="font-display font-bold text-sm md:text-base whitespace-nowrap">
      Télécharger l'app
    </span>
  </a>
);
